import { DatesModel } from "..";
import { DateRange } from "sb-bff-integration";
var WeekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
var Months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var OneDay = 1 * 24 * 60 * 60000;
var GroupedSportsToDatesMapper = /** @class */ (function () {
    function GroupedSportsToDatesMapper(dict) {
        this.dict = dict;
    }
    GroupedSportsToDatesMapper.prototype.getDates = function (response, today, timezone) {
        var timezoneShift = (today.getTimezoneOffset() + timezone * 60) * 60000;
        return response.sports ? this.mapToDates(response.sports, timezoneShift, today) : [];
    };
    GroupedSportsToDatesMapper.prototype.mapToDates = function (sports, timezoneShift, today) {
        var _this = this;
        return sports.reduce(this.groupsReducer.bind(this), []).map(function (date, index) { return _this.getDatesModel(date, index, timezoneShift, today); });
    };
    GroupedSportsToDatesMapper.prototype.groupsReducer = function (accumulator, current) {
        var count = current.sport ? this.getFixturesCount(current.sport) : 0;
        if (current.date && count > 0) {
            accumulator.push(new Date(current.date));
        }
        return accumulator;
    };
    GroupedSportsToDatesMapper.prototype.getDatesModel = function (date, index, timezoneShift, today) {
        var shiftedDate = this.shiftDate(date, timezoneShift);
        return new DatesModel({
            id: shiftedDate.getDate().toString(),
            from: date,
            timeRange: DateRange.TimeRangeEnum.OneDay,
            order: index,
            dayOfWeek: this.getDayOfWeek(date, today, shiftedDate.getDay()),
            formattedDate: this.getFormattedDate(shiftedDate)
        });
    };
    GroupedSportsToDatesMapper.prototype.getDayOfWeek = function (date, today, dayNumber) {
        var diff = date.getTime() - today.getTime();
        if (!diff) {
            return this.dict.Today;
        }
        else if (diff === OneDay) {
            return this.dict.Tomorrow;
        }
        else {
            return this.dict[WeekDays[dayNumber]];
        }
    };
    GroupedSportsToDatesMapper.prototype.getFormattedDate = function (date) {
        var day = date.getDate();
        var month = Months[date.getMonth()];
        return this.dict[month] + " " + day;
    };
    GroupedSportsToDatesMapper.prototype.shiftDate = function (day, timezoneShift) {
        return new Date(day.getTime() + timezoneShift);
    };
    GroupedSportsToDatesMapper.prototype.getFixturesCount = function (currentSport) {
        var fixturesCount = currentSport.fixturesCount ? currentSport.fixturesCount : 0;
        var liveFixturesTotalCount = currentSport.liveFixturesTotalCount ? currentSport.liveFixturesTotalCount : 0;
        return fixturesCount - liveFixturesTotalCount;
    };
    return GroupedSportsToDatesMapper;
}());
export { GroupedSportsToDatesMapper };
//# sourceMappingURL=DatesMapper.js.map